<script>
    import moment from 'moment'
    export default {
        name: "AimsOperationBaseInfo",
        props: {
            operation: {
                type: Object,
                default () {
                    return {}
                }
            }
        },
        data () {
            return {
            }
        },
        computed: {},
        created: function () {},
        mounted: function () {},
        beforeDestroy () {},
        watch: {
        },
        methods: {
        },
        filters: {
            dateFilter (value, pattern) {
                if (!value) {
                    value = ''
                }
                if (!pattern) {
                    pattern = 'YYYY-MM-DD'
                }
                return moment(value).format(pattern)
            },
            durationFilter (value) {
                if (value === '无') {
                    return '无'
                }
                return (Math.round(value * 10 / 1000 / 60 / 60) / 10) + '小时'
            }
        }
    }
</script>
<template>
    <div class="operation-content" v-if="operation">
        <el-row :gutter="20">
            <el-col :span="24">
                <span>诊断：{{operation.diagnoseNames || '无'}}</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <span>手术时间：{{operation.arrangedStartTime || operation.startTime || '无' | dateFilter('YYYY-MM-DD HH:mm:ss')}}</span>
            </el-col>
            <el-col :span="8">
                <span>手术间：{{operation.roomName || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>手术时长：{{operation.duration || '无' | durationFilter}}</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <span>主刀医生：{{operation.operatorName || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>一助：{{operation.assistantFirstName || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>二助：{{operation.assistantSecondName || '无'}}</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <span>术式：{{operation.operatingNames || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>麻醉方式：{{operation.anesthesiaType || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>手术间要求：{{operation.roomDemand || '无'}}</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <span>内固定材料：{{operation.specialPrepare || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>设备要求：{{operation.device || '无'}}</span>
            </el-col>
            <el-col :span="8">
                <span>备注：{{operation.remark || '无'}}</span>
            </el-col>
        </el-row>
    </div>
</template>
<style scoped>

</style>
